const trimSlash = (v: string): string => v.replace(/\/+$/, '');

const viteEnv = (import.meta as { env?: Record<string, string | undefined> }).env ?? {};

const envPublic = viteEnv.VITE_PUBLIC_URL;
const envAppBase = viteEnv.VITE_APP_BASE;
const envApiBase = viteEnv.VITE_AWENI_API_BASE;

export const PUBLIC_URL = trimSlash(
  envPublic || (typeof window !== 'undefined' ? window.location.origin : ''),
);
export const APP_BASE = trimSlash(envAppBase || '/aweni');
export const AWENI_API_BASE = trimSlash(envApiBase || `${APP_BASE}/api`);

export function buildApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${AWENI_API_BASE}${normalized}`;
}

export function buildPublicUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${PUBLIC_URL}${normalized}`;
}
